import { render, staticRenderFns } from "./RelatedClientSelect.vue?vue&type=template&id=f343f9e0&lang=pug"
import script from "./RelatedClientSelect.vue?vue&type=script&lang=js"
export * from "./RelatedClientSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,ClientSelect: require('/home/docker/code/frontend/components/ClientSelect.vue').default,Name: require('/home/docker/code/frontend/components/Name.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
